import _ from 'lodash';
import applyInfo from './applyInfo';
export default _.union(
  applyInfo,
  [{
    name: 'selfStudySystem',
    path: '/selfStudySystem',
    meta: { title: '自学成才系统' },
    component: require('views/common/blank.vue').default
  }]
);
